import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as customPropTypes from '@/custom-prop-types';
import { Button } from '@/design-system/atoms/Button';
import { LazyIconArrowRightCircle } from '@/design-system/atoms/Icons/IconArrowRightCircle/Lazy';
import { LazyIconExternalLink } from '@/design-system/atoms/Icons/IconExternalLink/Lazy';

import styles from './Title.module.scss';

/**
 * Card Title Component
 * @param {object} props
 * @param {object} props.ref - React ref object
 * @param {string} props.className - Additional class name
 * @param {object} props.link - Link object
 * @param {string} props.title - Title text
 * @param {object} props.otherProps - Additional props
 */
export const Title = React.forwardRef((props, ref) => {
    const { className, link, title, analytics, isInternal, ...otherProps } = props;

    return (
        <Button
            buttonStyle={Button.STYLE.TEXT_TITLE}
            label={title}
            iconRight
            iconComponent={isInternal ? LazyIconArrowRightCircle : LazyIconExternalLink}
            className={classnames(styles['title'], className)}
            fullWidth={{ md: true }}
            ref={ref}
            {...link}
            {...otherProps}
            analytics={analytics}
        />
    );
});

Title.displayName = 'Title';

Title.propTypes = {
    className: PropTypes.string,
    link: PropTypes.shape({
        csr: PropTypes.bool,
        href: PropTypes.string,
        target: PropTypes.string,
        rel: PropTypes.string,
    }),
    title: PropTypes.string,
    analytics: customPropTypes.analyticsPropType,
};

export default Title;
